import { render, staticRenderFns } from "./ResetPwdWindow.vue?vue&type=template&id=e22a750a&scoped=true&"
import script from "./ResetPwdWindow.vue?vue&type=script&lang=js&"
export * from "./ResetPwdWindow.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwdWindow.vue?vue&type=style&index=0&id=e22a750a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22a750a",
  null
  
)

export default component.exports